import {
  Grid,
  Button,
  ButtonGroup,
  TextField,
  Avatar,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Typography,
  CardActions,
  Stack,
  Container,
  Paper,
  Skeleton,
  IconButton,
} from "@mui/material";
import { useStyles } from "./HomeStyles";
import ColorLine from "../../components/ColorLine";
import colors from "../../themes/colors";
import TestimonialCard from "../../components/TestimonialCard";
// import Carousel from "react-material-ui-carousel";
import AvatarComponent from "../../components/AvatarComponent";
import DashboardSlide from "../../components/DashboardSlide";
import HighlightComponent from "../../components/HighlightComponent";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { getDoc, getDocs } from "firebase/firestore/lite";
import {
  clientColRefWithOrder,
  CompanyColRef,
  CompanyColRefWithOrder,
  ProductColRefWithOrder,
  TestimonialColRefWithOrder,
  userDocRef,
} from "../../database/Firebase";
import CommonContentBox from "../../components/CommonContentBox";
import { BlogColRefWithOrder } from "../../database/Firebase";
import { BlogHomePageCard } from "../../components/BlogCard";
// import Marquee from "react-fast-marquee";
import CountUp from "react-countup";
import ScrollAnimation from "react-animate-on-scroll";
import InputAdornment from "@mui/material/InputAdornment";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import { styled } from "@mui/styles";
// import Carousel2 from "./HomeUtils";
import Carousel from "react-elastic-carousel";
import "react-multi-carousel/lib/styles.css";
import Tilt from "react-parallax-tilt";
import Marquee from "react-marquee-master";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import SectionSlide from "./SectionSlide";
import ServiceCard from "../../components/ServiceCard";
import WorkImageGrid from "../../components/WorkImageGrid";
import {
  ServiceColRefWithOrder,
  WorkDoneColRefWithOrder,
} from "../../database/Firebase";
import Slider from "react-slick";
import Product from "../../components/Product";
import { useNavigate } from "react-router-dom";
import { storeCache, getCache, deleteCache } from "../../cache/cache";
import { LocalStorage } from "../../cache/localStorage";
import { CompanyKey, HomeKey } from "../../constant";
import { Helmet } from "react-helmet";
// const {Slider} = require('./components/Home').default
// const Background = require("../../assets/Background.png");

var breakPoints = [
  { width: 1, itemsToShow: 1 },
  { width: 550, itemsToShow: 3 },
  { width: 850, itemsToShow: 3 },
  { width: 1150, itemsToShow: 4 },
  { width: 1450, itemsToShow: 5 },
  { width: 1750, itemsToShow: 6 },
];

const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: colors.green,
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: colors.green,
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: colors.green,
      borderRadius: 0,
      borderWidth: 1,
      borderTopLeftRadius: 10,
      borderBottomLeftRadius: 10,
    },
    "&:hover fieldset": {
      borderColor: colors.green,
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.green,
    },
  },
});

declare global {
  namespace JSX {
    interface IntrinsicElements {
      marquee: any;
    }
  }
}

export default function HomeComponent() {
  let navigate = useNavigate();
  const carouselRef = useRef<any>(null);
  const carouselRefTesti = useRef<any>(null);

  const classes = useStyles();
  const [homeData, setHomeData] = useState({
    dashboardTitle: "",
    whatWeOffer: "",
    count1: "",
    count2: "",
    count3: "",
    GiftStore: "",
    GiftStoreFind: "",
    left: "",
    right: "",
  });
  const [clientList, setClientList] = useState<any[]>([]);
  const [TestimonialList, setTestimonialList] = useState<any[]>([]);
  const [BlogList, setBlogList] = useState<any[]>([]);
  const [serviceList, setServiceList] = useState<any[]>([]);
  const [WorkDoneList, setWorkDoneList] = useState([]);
  const [CompanyList, setCompanyList] = useState({
    aboutCompany: "",
    adsUrl: "",
    companyAdsDescription: "",
    companyAdsName: "",
    companyFounder: "",
    companyName: "",
    contact: "",
    banner_link: "",
    email: "",
    fabUrl: "",
    adsPortraitUrl: "",
    headline: "",
    planUrl: "",
    seo: "",
  });
  const [ProductList, setProductList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [Reload, setReload] = useState(false);
  const [emailValid, setEmailValid] = useState("");

  var carouselSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: false,
    responsive: [
      {
        breakpoint: 320,
        settings: { slidesToShow: 1, slidesToScroll: 1, infinite: false },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1, slidesToScroll: 1, infinite: false },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1, slidesToScroll: 1, infinite: false },
      },
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3, slidesToScroll: 3, infinite: false },
      },
    ],
  };

  const [BrandDevelopment, setBrandDevelopment] = useState<any>([]);
  const [PrintAndDigital, setPrintAndDigital] = useState<any>([]);
  const [Creating, setCreating] = useState<any>([]);
  const [Packaging, setPackaging] = useState<any>([]);
  const [Social, setSocial] = useState<any>([]);
  const [Web, setWeb] = useState<any>([]);

  useEffect(() => {
    // eslint-disable-next-line
    getHomeData();
    // eslint-disable-next-line
    getClient();
    // eslint-disable-next-line
    getTestimonial();
    // eslint-disable-next-line
    getBlog();
    // eslint-disable-next-line
    getService();
    // eslint-disable-next-line
    getWorkDone();
    // eslint-disable-next-line
    getCompany();
    // eslint-disable-next-line
    getProduct();
  }, []);

  const setWorkDone = (storeWorkDone: any) => {
    storeWorkDone.map((work: any) => {
      console.log("work", work);

      if (work.category === "Brand Development") {
        setBrandDevelopment((oldArray: any) => [...oldArray, work]);
      } else if (work.category === "Print & Digital Design") {
        setPrintAndDigital((oldArray: any) => [...oldArray, work]);
      } else if (work.category === "Creating & Editing Services") {
        setCreating((oldArray: any) => [...oldArray, work]);
      } else if (work.category === "Packaging Designs") {
        setPackaging((oldArray: any) => [...oldArray, work]);
      } else if (work.category === "Social Media Creatives") {
        setSocial((oldArray: any) => [...oldArray, work]);
      } else if (work.category === "Web & Interactive Designs (UI/UX)") {
        setWeb((oldArray: any) => [...oldArray, work]);
      }
    });

    console.log("BrandDevelopment", BrandDevelopment);
  };

  let getProduct = async () => {
    setIsLoading(true);
    const response = await getDocs(ProductColRefWithOrder);
    let storeProduct: any = [];
    response.forEach((doc) => {
      storeProduct.push({
        ...doc.data(),
        doc_id: doc.id,
      });
    });
    console.log(storeProduct);
    setProductList(storeProduct);
    setIsLoading(false);
  };

  let getCompany = async () => {
    setIsLoading(true);
    const response = await getDocs(CompanyColRef);
    let Company: any = [];
    response.forEach((doc) => {
      Company.push({
        ...doc.data(),
        doc_id: doc.id,
      });
    });
    if (Company.length) {
      setCompanyList(Company[0]);
      //store in local
      LocalStorage.store(CompanyKey, Company[0]);
    }
    setIsLoading(false);
  };

  let getService = async () => {
    setIsLoading(true);
    const response = await getDocs(ServiceColRefWithOrder);
    let storeService: any = [];
    response.forEach((doc) => {
      storeService.push({
        ...doc.data(),
        doc_id: doc.id,
      });
    });
    console.log(storeService, isLoading);
    setServiceList(storeService);
    setIsLoading(false);
  };

  let getWorkDone = async () => {
    setIsLoading(true);
    const response = await getDocs(WorkDoneColRefWithOrder);
    let storeWorkDone: any = [];
    response.forEach((doc) => {
      storeWorkDone.push({
        ...doc.data(),
        doc_id: doc.id,
      });
    });
    setWorkDoneList(storeWorkDone);
    setIsLoading(false);
    setWorkDone(storeWorkDone);
  };

  let getBlog = async () => {
    setIsLoading(true);
    const response = await getDocs(BlogColRefWithOrder);
    let storeBlog: any = [];
    response.forEach((doc) => {
      storeBlog.push({
        ...doc.data(),
        doc_id: doc.id,
      });
    });
    console.log(storeBlog, isLoading);
    setBlogList(storeBlog);
    setIsLoading(false);
  };

  const getHomeData = async () => {
    try {
      setIsLoading(true);
      const response = await getDoc(userDocRef);
      setIsLoading(false);
      if (response.exists()) {
        setHomeData({ ...homeData, ...response.data() });
        LocalStorage.store(HomeKey, { ...homeData, ...response.data() });
      }
    } catch (error) {
      console.log("error", error, isLoading);
      setIsLoading(false);
    }
  };

  let getClient = async () => {
    setIsLoading(true);
    const response = await getDocs(clientColRefWithOrder);
    let storeClient: any = [];
    response.forEach((doc) => {
      storeClient.push({
        ...doc.data(),
        doc_id: doc.id,
      });
    });
    if (storeClient.length) {
      let arr = [...chunks(storeClient, 5)];
      setClientList(arr);
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  let getTestimonial = async () => {
    setIsLoading(true);
    const response = await getDocs(TestimonialColRefWithOrder);
    let storeTestimonial: any = [];
    response.forEach((doc) => {
      storeTestimonial.push({
        ...doc.data(),
        doc_id: doc.id,
      });
    });
    if (storeTestimonial.length) {
      let arr = storeTestimonial;
      setTestimonialList(arr);
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  const chunks = function (array: any, size: any) {
    let results = [];
    while (array.length) {
      results.push(array.splice(0, size));
    }
    return results;
  };

  const getCounterAnimation = (value: number) => {
    return <CountUp end={value} />;
  };
  let resetTimeout: NodeJS.Timeout;
  let resetTimeoutTesti: NodeJS.Timeout;

  return (
    <>
      <section>
        <DashboardSlide
          title="For the love of Creativity"
          description=""
          color="green"
          img="dashboardBg"
        />
      </section>
      <ColorLine />

      <section className={classes.section}>
        <div className="marginContainer">
          <p className={classes.sectionTitle}>What We Offer</p>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            pb={4}
          >
            <Grid item xs={12} sm={12} style={{ textAlign: "center" }}>
              <ScrollAnimation animateIn="fadeIn">
                {homeData.whatWeOffer ? (
                  <p>{homeData.whatWeOffer}</p>
                ) : (
                  <>
                    <Skeleton variant="text" />
                    <Skeleton variant="text" />
                    <Skeleton variant="text" />
                  </>
                )}
              </ScrollAnimation>
            </Grid>
          </Grid>
        </div>
      </section>
      <section
        style={{
          backgroundColor: colors.dark_blue,
        }}
      >
        {serviceList.length === 0 ? (
          <Skeleton variant="rectangular" width={"100vw"} height={518} />
        ) : (
          <div className="marginContainer" style={{ paddingBottom: 30 }}>
            <Carousel
              // initialActiveIndex={0}
              // easing="cubic-bezier(1,.15,.55,1.54)"
              // tiltEasing="cubic-bezier(0.110, 1, 1.000, 0.210)"
              // transitionMs={700}
              isRTL={false}
              showArrows={true}
              enableAutoPlay={true}
              autoPlaySpeed={6000}
              ref={carouselRef}
              // onNextEnd={({ index }) => {
              //   console.log(";index", index);
              //   clearTimeout(resetTimeout);
              //   if (index === 5) {
              //     resetTimeout = setTimeout(() => {
              //       carouselRef?.current?.goTo(0);
              //     }, 5000);
              //   }
              // }}
            >
              {serviceList &&
                serviceList.map((item, index) => {
                  let workDonelist: any[] = [];
                  if (item.title === "Brand Development") {
                    workDonelist = BrandDevelopment;
                  } else if (item.title === "Print & Digital Design") {
                    workDonelist = PrintAndDigital;
                  } else if (item.title === "Creating & Editing Services") {
                    workDonelist = Creating;
                  } else if (item.title === "Packaging Designs") {
                    workDonelist = Packaging;
                  } else if (item.title === "Social Media Creatives") {
                    workDonelist = Social;
                  } else if (
                    item.title === "Web & Interactive Designs (UI/UX)"
                  ) {
                    workDonelist = Web;
                  }
                  return (
                    <div>
                      <SectionSlide
                        serviceData={{ data: item, i: index }}
                        WorkDoneList={workDonelist}
                      />
                    </div>
                  );
                })}
            </Carousel>
          </div>
        )}
        {/* </Carousel2> */}
      </section>

      <ColorLine />
      <section>
        <div className="marginContainer">
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            style={{ textAlign: "center" }}
            pt={10}
          >
            <ScrollAnimation animateIn="fadeIn">
              <Grid
                sx={{
                  display: { xs: "none", lg: "block" },
                }}
                item
                style={{ textAlign: "center" }}
              >
                {!CompanyList.adsUrl ? (
                  <Skeleton
                    variant="rectangular"
                    width={"100vw"}
                    height={518}
                  />
                ) : (
                  <a target="_blank" href={CompanyList.banner_link}>
                    <Avatar
                      variant="square"
                      sx={{ width: "100%", height: 200 }}
                      alt="juju designz ads banner"
                      src={CompanyList.adsUrl}
                    />
                  </a>
                )}
              </Grid>
              <Grid
                sx={{
                  display: { xs: "block", lg: "none" },
                }}
                xs={12}
                item
                style={{ textAlign: "center" }}
              >
                {!CompanyList.adsUrl ? (
                  <Skeleton
                    variant="rectangular"
                    width={"100vw"}
                    height={518}
                  />
                ) : (
                  <a target="_blank" href={CompanyList.banner_link}>
                    <Avatar
                      variant="square"
                      sx={{ width: "100%", height: 200 }}
                      alt="juju designz ads banner"
                      src={CompanyList.adsPortraitUrl}
                    />
                  </a>
                )}
              </Grid>
            </ScrollAnimation>
          </Grid>
        </div>
      </section>
      <section className={classes.section}>
        <div className="marginContainer">
          <p className={classes.sectionTitle}>JuJu Gifts Store</p>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            style={{ textAlign: "center" }}
          >
            <Grid pt={0} item sm={12} style={{ textAlign: "center" }}>
              <ScrollAnimation animateIn="fadeIn">
                <p>{homeData.GiftStore}</p>
              </ScrollAnimation>
            </Grid>
          </Grid>
        </div>
      </section>

      <section style={{ backgroundColor: "#F7F7F7" }}>
        <div className="marginContainer">
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{ textAlign: "center" }}
            pt={2}
            pb={2}
          >
            <Grid
              item
              sm={4}
              xs={6}
              direction={"column"}
              display={{ xs: "none", lg: "block" }}
            >
              <Grid item>
                <marquee
                  loop="INFINITE"
                  height="500"
                  behavior="scroll"
                  direction="down"
                  scrollamount="3"
                >
                  {[
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                  ].map((item: any, index) => {
                    return (
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate({
                            pathname: "/Gift-Store-Details",
                            search: `?id=${item.doc_id}`,
                          })
                        }
                      >
                        <Avatar
                          key={index}
                          variant="square"
                          sx={{ width: 200, height: 200, marginTop: 5 }}
                          alt={"juju design salem"}
                          src={item.url}
                        />
                      </div>
                    );
                  })}
                </marquee>
              </Grid>
            </Grid>
            <Grid
              item
              sm={4}
              xs={6}
              direction={"column"}
              display={{ xs: "none", lg: "block" }}
            >
              <Grid item>
                <marquee
                  loop="INFINITE"
                  height="500"
                  behavior="scroll"
                  direction="down"
                  scrollamount="4"
                >
                  {[
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                    ...ProductList,
                  ].map((item: any, index) => {
                    return (
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate("/Gift-Store")}
                      >
                        <Avatar
                          key={index}
                          variant="square"
                          sx={{ width: 200, height: 200, marginTop: 5 }}
                          alt={"juju design salem"}
                          src={item.url}
                        />
                      </div>
                    );
                  })}
                </marquee>
              </Grid>
            </Grid>

            <Grid
              item
              sm={4}
              xs={12}
              alignItems={"center"}
              justifyContent={"center"}
              pt={4}
              pb={4}
            >
              <Tilt>
                <Card
                  sx={{
                    borderWidth: 0,
                    borderRadius: 5,
                  }}
                  elevation={5}
                >
                  <CardMedia
                    component="img"
                    height="auto"
                    image={
                      "https://firebasestorage.googleapis.com/v0/b/juju-designz---production.appspot.com/o/Asset%2Fgifts-background.jpg?alt=media&token=8e5af0ad-dadd-471b-b28c-7528d8dbc375"
                    }
                    alt="juju Designz Gift Store"
                  />
                  <CardContent>
                    <Typography
                      gutterBottom
                      variant="h5"
                      component="div"
                      style={{ fontWeight: "bold", textAlign: "left" }}
                    >
                      Pick Your Perfect Gifts
                    </Typography>
                    <div style={{ textAlign: "left" }}>
                      <p>{homeData.GiftStoreFind}</p>
                    </div>
                  </CardContent>
                  <CardActions style={{ justifyContent: "center" }}>
                    <Button
                      className="jump"
                      onClick={() => navigate("/Gift-Store")}
                      style={{
                        background:
                          "linear-gradient(90deg, rgba(102,214,30,1) 0%, rgba(87,178,29,1) 53%)",
                        color: "white",
                        paddingLeft: 10,
                        paddingRight: 10,
                        marginBottom: 10,
                        textTransform: "capitalize",
                      }}
                      size="small"
                    >
                      Shop Now
                    </Button>
                  </CardActions>
                </Card>
              </Tilt>
            </Grid>
          </Grid>
        </div>
      </section>
      <section className={classes.section}>
        <div className="marginContainer1">
          <p className={classes.sectionTitle}>Number Speaks Loud</p>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{ textAlign: "center" }}
            pb={4}
          >
            <Grid item xs={12} sm={3} pt={4}>
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent={"center"}
              >
                <div>
                  <img
                    src={require("../../assets/Icons_Growth.png")}
                    width={60}
                    height={60}
                    alt="juju Designz popup"
                  />
                </div>

                <div>
                  <p className={classes.countNumber}>
                    <ScrollAnimation
                      animateIn="fadeIn"
                      afterAnimatedIn={(): any => {
                        setReload(true);
                      }}
                      afterAnimatedOut={(): any => {
                        setReload(false);
                      }}
                    >
                      {Reload
                        ? getCounterAnimation(parseInt(homeData.count1))
                        : 0}
                    </ScrollAnimation>
                  </p>
                </div>
              </Stack>
              <p className={classes.countMessage}>Years of journey</p>
            </Grid>
            <Grid item xs={12} sm={3} pt={4}>
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent={"center"}
              >
                <div>
                  <img
                    src={require("../../assets/Icons_HappyClients.png")}
                    width={60}
                    height={60}
                    alt="juju Designz popup"
                  />
                </div>
                <div>
                  <p className={classes.countNumber}>
                    <ScrollAnimation
                      animateIn="fadeIn"
                      afterAnimatedIn={(): any => {
                        setReload(true);
                      }}
                      afterAnimatedOut={(): any => {
                        setReload(false);
                      }}
                    >
                      {Reload
                        ? getCounterAnimation(parseInt(homeData.count2))
                        : 0}
                    </ScrollAnimation>
                  </p>
                </div>
              </Stack>
              <p className={classes.countMessage}>Happy Clients</p>
            </Grid>
            <Grid item xs={12} sm={3} pt={4}>
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent={"center"}
              >
                <div>
                  <img
                    src={require("../../assets/Icons_SuccessStory.png")}
                    width={60}
                    height={60}
                    alt="juju Designz popup"
                  />
                </div>
                <div>
                  <p className={classes.countNumber}>
                    <ScrollAnimation
                      animateIn="fadeIn"
                      afterAnimatedIn={(): any => {
                        setReload(true);
                      }}
                      afterAnimatedOut={(): any => {
                        setReload(false);
                      }}
                    >
                      {Reload
                        ? getCounterAnimation(parseInt(homeData.count3))
                        : 0}
                    </ScrollAnimation>
                  </p>
                </div>
              </Stack>
              <p className={classes.countMessage}>Successful Projects</p>
            </Grid>
          </Grid>
        </div>
      </section>
      <section style={{ backgroundColor: colors.dark_blue, paddingBottom: 70 }}>
        <p
          style={{
            fontSize: 25,
            textAlign: "center",
            paddingTop: 20,
            paddingBottom: 10,
            color: colors.white,
          }}
        >
          What People Says
        </p>
        {TestimonialList.length === 0 ? (
          <Skeleton variant="rectangular" width={"100vw"} height={518} />
        ) : (
          <div className="marginContainer">
            <Carousel
              itemPadding={[10, 10]}
              isRTL={false}
              breakPoints={breakPoints}
              itemPosition={"CENTER"}
              showArrows={true}
              enableAutoPlay={true}
              autoPlaySpeed={6000}
              ref={carouselRefTesti}
              // onNextEnd={({ index }) => {
              //   console.log("Testi", index);
              //   clearTimeout(resetTimeoutTesti);
              //   if (index === index) {
              //     resetTimeoutTesti = setTimeout(() => {
              //       carouselRefTesti?.current?.goTo(0);
              //     }, 5000);
              //   }
              // }}
            >
              {TestimonialList &&
                TestimonialList.map((item, index) => {
                  return (
                    <div key={index}>
                      <TestimonialCard TestimonialData={item} />
                    </div>
                  );
                })}
            </Carousel>
          </div>
        )}
      </section>
      <ColorLine />
      <section className={classes.section} style={{ paddingBottom: 40 }}>
        <p className={classes.sectionTitle}>Happy Clients</p>

        <ScrollAnimation animateIn="fadeIn">
          <div className="marginContainer">
            {clientList &&
              clientList.slice(0, 1).map((item, index) => {
                return (
                  <AvatarComponent key={index} ClientList={item} from="home" />
                );
              })}
          </div>
        </ScrollAnimation>
        <div style={{ textAlign: "center" }}>
          {/* <motion.div whileHover={{ scale: 0.99 }}> */}
          <Button
            className="jump"
            onClick={() => navigate("Client-List")}
            style={{
              background:
                "linear-gradient(90deg, rgba(102,214,30,1) 0%, rgba(87,178,29,1) 53%)",
              color: "white",
              paddingLeft: 10,
              paddingRight: 10,
              marginBottom: 10,
              marginTop: 30,
              textTransform: "capitalize",
            }}
            size="small"
          >
            View More
          </Button>
          {/* </motion.div> */}
        </div>
      </section>

      <section>
        <p className={classes.sectionTitle}>Recent Blogs</p>
        <ScrollAnimation animateIn="fadeIn">
          <div className="marginContainer">
            <Grid
              container
              alignItems="center"
              justifyContent={"space-between"}
              // p={4}
              mb={4}
              pb={4}
              spacing={4}
            >
              {BlogList &&
                BlogList.slice(0, 3).map((item, index) => {
                  return (
                    <Grid key={index} item sm={4} mt={4}>
                      <BlogHomePageCard BlogData={item} />
                    </Grid>
                  );
                })}
            </Grid>
          </div>
        </ScrollAnimation>
      </section>
      <section>
        <div className="marginContainer">
          <Grid
            container
            alignItems={"center"}
            justifyContent={"center"}
            mb={4}
          >
            <Grid
              item
              xs={12}
              sm={12}
              p={4}
              style={{
                backgroundColor: colors.dark_blue,
                borderRadius: 10,
                textAlign: "center",
              }}
            >
              <p
                style={{ paddingTop: 10 }}
                className={classes.darkSectionTitle}
              >
                Get Our Brochure
              </p>
              <ButtonGroup variant="contained" aria-label="large button group">
                <CssTextField
                  id="outlined-adornment-weight"
                  value={emailValid}
                  onChange={(e) => {
                    setEmailValid(e.target.value);
                  }}
                  placeholder="Enter Mail ID*"
                  aria-describedby="outlined-weight-helper-text"
                  inputProps={{
                    "aria-label": "weight",
                  }}
                  style={{ width: "70%", borderRadius: 0 }}
                  sx={{
                    input: {
                      color: colors.white,
                      borderColor: colors.green,
                      borderRadius: 0,
                    },
                  }}
                />
                <Button
                  // onClick={() => {
                  //   var validRegex =
                  //     /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                  //   if (emailValid.match(validRegex)) {
                  //     setEmailValid("");
                  //     window.open(CompanyList.planUrl);
                  //   } else {
                  //     alert("Enter valid email ID to get the plan details !");
                  //   }
                  // }}
                  style={{
                    background:
                      "linear-gradient(90deg, rgba(102,214,30,1) 0%, rgba(87,178,29,1) 53%)",
                    borderRadius: 0,
                    borderTopRightRadius: 10,
                    borderBottomRightRadius: 10,
                    textTransform: "capitalize",
                  }}
                >
                  Download
                </Button>
              </ButtonGroup>
            </Grid>
          </Grid>
        </div>
      </section>
      {/* SEO */}
      <Helmet>
        <title>JuJu Designz Home</title>
        <meta
          name="description"
          content="JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider  juju designs juju, designsz of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated  juju designs juju, designsz and  juju designs juju, designsz amused to see our customers exhilarated. location : salem , Tamil Nadu , graphics design , web designing , mobile app development . best startup in salem , best web development in salem , juju designs juju, designsz.salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination/Visualisation.JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated and amused to see our customers exhilarated.,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Struggling to find a creative/design solution? Here is a good nes for you! Go through our wide range of services to fulfil your needs, and we get immense pleasure to make it for you. Start exploring JuJu!,Join hands to build your business and turn your brand to become customer's favourite.,We make graphic designs that can be printed on any physical medium, and on the other hand you can also have graphic designs for yor digital purpose across various platforms.,We create brand new product images and also add magic to your existing ones. (or  We add magic to images for every needs.) ,We add creative brand design and make your product packaging & labelling even more interesting to get you uniquely identified among customers.,We make responsive, up-to date and good quality design customized as per your needs. And, we think from the user side for providing great interactive experience in every visit.,Thanks for landing in JuJu's gift store! Hope our creative collectives makes you happy.We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination/Visualisation,JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated and amused to see our customers exhilarated.,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift Store,,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Struggling to find a creative/design solution? Here is a good nes for you! Go through our wide range of services to fulfil your needs, and we get immense pleasure to make it for you. Start exploring JuJu!,Join hands to build your business and turn your brand to become customer's favourite.,We make graphic designs that can be printed on any physical medium, and on the other hand you can also have graphic designs for yor digital purpose across various platforms.,We create brand new product images and also add magic to your existing ones. (or  We add magic to images for every needs.) ,We add creative brand design and make your product packaging & labelling even more interesting to get you uniquely identified among customers.,We make responsive, up-to date and good quality design customized as per your needs. And, we think from the user side for providing great interactive experience in every visit.,Thanks for landing in JuJu's gift store! Hope our creative collectives makes you happy.We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination/Visualisation,JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated and amused to see our customers exhilarated.,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift Store,,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Struggling to find a creative/design solution? Here is a >good nes for you! Go through our wide range of services to fulfil your needs, and we get immense pleasure to make it for you. Start exploring JuJu!,Join hands to build your business and turn your brand to become customer's favourite.,We make graphic designs that can be printed on any physical medium, and on the other hand you can also have graphic designs for yor digital purpose across various platforms.,We create brand new product images and also add magic to your existing ones. (or  We add magic to images for every needs.) ,We add creative brand design and make your product packaging & labelling even more interesting to get you uniquely identified among customers.,We make responsive, up-to date and good quality design customized as per your needs. And, we think from the user side for providing great interactive experience in every visit.,Thanks for landing in JuJu's gift store! Hope our creative collectives makes you happy.We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination/Visualisation,JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated and amused to see our customers exhilarated.,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift Store,,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Struggling to find a creative/design solution? Here is a good nes for you! Go through our wide range of services to fulfil your needs, and we get immense pleasure to make it for you. Start exploring JuJu!,Join hands to build your business and turn your brand to become customer's favourite.,We make graphic designs that can be printed on any physical medium, and on the other hand you can also have graphic designs for yor digital purpose across various platforms.,We create brand new product images and also add magic to your existing ones. (or  We add magic to images for every needs.) ,We add creative brand design and make your product packaging & labelling even more interesting to get you uniquely identified among customers.,We make responsive, up-to date and good quality design customized as per your needs. And, we think from the user side for providing great interactive experience in every visit.,Thanks for landing in JuJu's gift store! Hope our creative collectives makes you happy.We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift Store,,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Struggling to find a creative/design solution? Here is a good nes for you! Go through our wide range of services to fulfil your needs, and we get immense pleasure to make it for you. Start exploring JuJu!,Join hands to build your business and turn your brand to become customer's favourite.,We make graphic designs that can be printed on any physical medium, and on the other hand you can also have graphic designs for yor digital purpose across various platforms.,We create brand new product images and also add magic to your existing ones. (or  We add magic to images for every needs.) ,We add creative brand design and make your product packaging & labelling even more interesting to get you uniquely identified among customers.,We make responsive, up-to date and good quality design customized as per your needs. And, we think from the user side for providing great interactive experience in every visit.,Thanks for landing in JuJu's gift store! Hope our creative collectives makes you happy.We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination/Visualisation,JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated and amused to see our customers exhilarated.,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift Store,,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store"
        />
      </Helmet>
    </>
  );
}
